import React from "react";

import ThankYouComponent from "../components/ThankYouComponent";
import TagMeetingHeader from "../components/TagMeetingHeader";

const ThankYouPage = () => {
  return (
    <>
      <TagMeetingHeader headerName={"Tag Meeting"} />
      <ThankYouComponent  message={"Thank you, your meeting has been tagged for the day!"}/>
    </>
  );
};

export default ThankYouPage;
